import React from "react";
import { Link } from "react-router-dom";

function Menubar() {
  return (
    <div className="menu">
      <h1>
        <Link to="/" className="logo">
          BINGE-MAX
        </Link>
      </h1>
    </div>
  );
}

export default Menubar;
